<template>
  <v-card>
    <v-card-text style=" height: 150px;position: sticky;top: 80px;z-index: 1;overflow: hidden auto;box-shadow: 0 0 black;"  class="grey lighten-4 white--text">
      <OrderListItem :order="{
        seller: {
          order_ref: '0001',
          name: 'George'
        },
        pickup: {
          date: '2019-07-01',
          address: 'Brno'
        },
        buyer: {
          order_ref: '0001_buyer',
          name: 'Nikos'
        },
        delivery: {
          date: '2019-07-16',
          address: 'Prague'
        },
        weight: 10,
        volume: 3,
        packages: 1,
        status: statusChanging
      }" />
    </v-card-text>
    <v-card-text>
            <v-timeline
  dense
  clipped
  >
    <template v-if="getResults.length > 0 && toggleView === 'Time'">
      <v-timeline-item :key="event.id + '_key'" v-for="(event) in getResults"
      :color="colorPerEvent(event.eventType)"
      fill-dot
      left
      small
      >
      <!-- <template v-slot:opposite>
        <span>{{event.eventTime}}</span>
      </template> -->
      <v-row justify="space-between">
          <v-col cols="7">
            <v-card :class="colorPerEvent(event.eventType)" class="white--text"  @click="" avatar ripple>
              <!-- <v-card-title :class="colorPerEvent(event.eventType)" class="headline">{{event.actor}}</v-card-title>
              <v-card-text>
                <p>
                  Event: {{event.eventType}}
                </p>
              </v-card-text> -->
              <v-card-title primary-title>
                <div>
                  <div class="headline">{{event.actor.split(':')[1]}}</div>
                  <span>{{event.eventType}}</span>
                </div>
              </v-card-title>
            </v-card>
          </v-col>
          <v-col class="text-right" cols="5">{{event.eventTime}}</v-col>
      </v-row>

      </v-timeline-item>
    </template>
    <div v-else class="text-center">
      <v-progress-circular
      :width="7"
      :size="70"
      color="red"
      indeterminate
    ></v-progress-circular>
    </div>
  </v-timeline>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import { generalHelpers } from '@/_helpers'
import OrderListItem from '@/components/orders/OrderListItem'
export default {
  name: 'NotificationsNewsFeedList',
  components: {
    OrderListItem
  },
  data () {
    return {
      activities: [],
      generalHelpers: generalHelpers,
      toggleView: 'Time'
    }
  },
  methods: {
    NotificationsCardComponentAttributes (key, activity) {
      switch (key) {
        case 'Order':
          return {
            title: this.titleVerbOrderId(activity.object),
            actor: activity.actor.split(':')[1],
            time: generalHelpers.calculateTimeDifferences(activity.time),
            action: this.actionString(activity.object)
          }
      }
    },
    titleVerbOrderId (object) {
      const splitObject = object.split(':')
      return `${splitObject[0]}:${splitObject[1]}`
    },
    actionString (object) {
      const splitObject = object.split(':')
      return `${splitObject[2]}`
    },
    groubBy (key) {
      return (array) =>
        array.reduce((objectsByKeyValue, obj) => {
          const value = obj[key]
          objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj)
          return objectsByKeyValue
        }, {})
    },
    colorPerEvent (type) {
      switch (type) {
        case 'Accepted':
          return 'blue darken-4'
        case 'ReadyForProduction':
          return 'blue darken-3'
        case 'InProduction':
          return 'blue darken-3'
        case 'InWarehouse':
          return 'blue darken-2'
        case 'Scheduled':
          return 'blue darken-2'
        case 'ReScheduled':
          return 'blue darken-1'
        case 'CargoReady':
          return 'blue darken-1'
        case 'OnTheWay':
          return 'blue'
        case 'Delivered':
          return 'green'
      }
    }
  },
  computed: {
    ...mapGetters([
      'getNotificationsActivities',
      'getNotificationsUserFeedStream',
      'getNotificationsSortedKahnsAlgorithm'
    ]),
    getResults () {
      let results = this.getNotificationsSortedKahnsAlgorithm
      if (results !== undefined) {
        // const groupedTime = this.groubBy('eventTime')(results)
        // const groupedLocation = Object.keys(groupedTime).map((key) => {
        //   return { [key]: this.groubBy('node')(groupedTime[key]) }
        // })
        // console.log(groupedLocation)
        // return [...groupedLocation]
        return results
      }
      return {}
    },
    statusChanging () {
      return 'Delivered'
    }
  }
}
</script>

<style>

</style>
